'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoBox = function (_React$Component) {
  (0, _inherits3.default)(InfoBox, _React$Component);

  function InfoBox() {
    (0, _classCallCheck3.default)(this, InfoBox);
    return (0, _possibleConstructorReturn3.default)(this, (InfoBox.__proto__ || (0, _getPrototypeOf2.default)(InfoBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoBox, [{
    key: 'render',
    value: function render() {
      var styles = require('./InfoBox.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.row + ' ' + styles.margins },
        _react2.default.createElement(
          'div',
          { className: styles['col-md-12'] },
          _react2.default.createElement(
            'div',
            { className: styles['section-block'] },
            _react2.default.createElement(
              'div',
              { className: '' + styles.header },
              _react2.default.createElement('img', { className: styles.icon, src: this.props.icon }),
              _react2.default.createElement(
                'h3',
                null,
                this.props.title
              )
            ),
            this.props.children
          )
        )
      );
    }
  }]);
  return InfoBox;
}(_react2.default.Component);

exports.default = InfoBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoBox/InfoBox.jsx
// module id = 2685
// module chunks = 0